export default __webpack_public_path__ + "static/media/arrowLeft.63de7483.svg";